import React, { useState } from 'react';
import { Account, User } from '../../types/userTypes';
import {
  filterAccountsBasedOnCountry,
  filterAccountsBasedOnUserType,
} from '../create-user/CreateUser';

async function onAccountSelected(
  value: string,
  accounts: any[],
  updateUser: any,
  setAccountIdSelected: any
): Promise<void> {
  const accountIdSelected = value ? parseInt(value) : null;
  const account = accountIdSelected
    ? accounts.find(acc => acc.id === accountIdSelected)
    : null;

  if (account) {
    await updateUser({
      accountId: accountIdSelected,
      companyName: account.name,
      companyNumber: account.companyNumber,
      paymentByInvoiceAllowed: account.paymentByInvoiceAllowed,
    });
  } else {
    await updateUser({ accountId: accountIdSelected });
  }

  setAccountIdSelected(accountIdSelected);
}
export function AccountRow({
  classNameSpan = '',
  classNameDiv = '',
  fetchingAccounts,
  accounts,
  updateUser,
  accountId,
  userToUpdate,
  newUser,
  filterForCountry,
}: {
  classNameSpan?: string;
  classNameDiv?: string;
  fetchingAccounts: boolean;
  accounts: Account[];
  updateUser: any; //(updatedUserFields: Partial<EditUser>) => void;
  accountId: number;
  userToUpdate: User;
  newUser: Partial<User>;
  filterForCountry: boolean;
}): JSX.Element {
  const [accountIdSelected, setAccountIdSelected] = useState<number>(accountId);
  const [sortByOrgNumber, setSortByOrgNumber] = useState<boolean>(false);
  const disableChanges =
    window.location.host.endsWith('porterbuddy.com') &&
    newUser.role === 'COURIER';
  const account = accountId
    ? accountIdSelected
      ? accounts.find(acc => acc.id === accountIdSelected)
      : null
    : null;

  const filteredAccounts = accounts
    .filter(acc => filterAccountsBasedOnUserType(userToUpdate, acc))
    .filter(
      acc => !filterForCountry || filterAccountsBasedOnCountry(newUser, acc)
    );

  return (
    <div className={'edit-user-modal__form-group'}>
      <label>
        <span className={classNameSpan}>Sorting</span>
        <div className={classNameDiv}>
          <label>
            <input
              disabled={disableChanges}
              type="checkbox"
              onChange={event => {
                setSortByOrgNumber(prevState => !prevState);
              }}
            />
            By organisation number
          </label>
        </div>
      </label>
      <label>
        <span className="edit-user-modal__form-label">Account</span>
        <select
          disabled={disableChanges}
          onChange={async e =>
            await onAccountSelected(
              e.target.value,
              accounts,
              updateUser,
              setAccountIdSelected
            )
          }
          value={accountIdSelected ? accountIdSelected.toString() : ''}
          className={
            !fetchingAccounts && accountIdSelected !== accountId
              ? 'edit-user-modal__modified'
              : undefined
          }
        >
          {(!fetchingAccounts && accountIdSelected && !account) ||
            (accountId === null && (
              <option value={''}>{'< ACCOUNT NOT FOUND! >'} </option>
            ))}
          {!filteredAccounts.some(acc => {
            return acc.id === accountIdSelected;
          }) && <option value={accountIdSelected}>Select an account!</option>}
          {filteredAccounts
            .sort((a: Account, b: Account) => {
              if (sortByOrgNumber) {
                if (a.companyNumber < b.companyNumber) {
                  return -1;
                } else if (a.companyNumber === b.companyNumber) {
                  return 0;
                } else {
                  return 1;
                }
              }
              return 1;
            })
            .map(account => (
              <option
                key={`edit-user-account-${account.id}`}
                value={account.id.toString()}
              >
                {sortByOrgNumber
                  ? `${account.companyNumber} - ${account.name}`
                  : `${account.name} — ${account.email}`}
              </option>
            ))}
        </select>
      </label>
    </div>
  );
}
